import { createContext, useReducer, useEffect } from 'react';

export const AuthContext = createContext();

export const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                user: action.payload.user,
                token: action.payload.token,
            };
        case 'LOGOUT':
            return { 
                ...state,
                user: null, 
                token: null 
            };
        case 'UPDATE_USER':
            const userLoginData = {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload,
                },
            };

            // Save in the same shape as login: { token, user }
            localStorage.setItem('user', JSON.stringify(userLoginData));

            return userLoginData;
        case 'AUTH_IS_READY':
            return {
                ...state,
                authIsReady: true
            };
        default:
            return state;
    }
}

export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: null,
        token: null,
        authIsReady: false
    });

    useEffect(() => {
        const stored = localStorage.getItem('user');

        if (stored) {
            try {
                dispatch({ type: 'LOGIN', payload: JSON.parse(stored) });
            } catch (error) {
                console.error('Failed to parse stored user: ', error);
                localStorage.removeItem('user');
            }
        }
        
        // Mark auth as ready regardless of whether a user was found
        dispatch({ type: 'AUTH_IS_READY' });
    }, []);

    return (
        <AuthContext.Provider value={{ ...state, dispatch }} >
            {children}
        </AuthContext.Provider>
    );
};